import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import appSelectors from '@/redux/app/appSelectors';

import appOperations from '@/redux/app/appOperations';

const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

const useTranslation = () => {
  const dispatch = useDispatch();

  const lang = useSelector(appSelectors.language);

  useEffect(() => {
    if (!lang?.code) return;

    dispatch(appOperations.getTranslation({ lang: lang.code }));
  }, [dispatch, lang?.code]);

  useEffect(() => {
    const isRTL = RTL_LANGUAGES.includes(lang?.code);

    if (isRTL) {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = lang?.code;
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = lang?.code;
    }
  }, [lang?.code]);
};

export default useTranslation;
